import type { Database } from './adatbazis.ts';

export type LeadStatusz = Database['public']['Enums']['lead_statusz'];
export type IngatlanTipus = Database['public']['Enums']['ingatlan_tipus'];
export type TagSzerep = Database['public']['Enums']['tag_szerep'];

export { TIPUS_CIMKE } from '../../../web/src/lib/cimkek.ts';

export const STATUSZ_CIMKE: Record<LeadStatusz, string> = {
  nem_ellenorzott: 'Nem ellenőrzött',
  uj: 'Új',
  elerve: 'Elérve',
  kesobb_aktualis: 'Később aktuális',
  szemle_egyeztetve: 'Szemle egyeztetve',
  szemle_megtortent: 'Szemle megtörtént',
  megbizas: 'Megbízás',
  eladva: 'Eladva',
  elveszett: 'Elveszett',
};

export const STATUSZ_SORREND: LeadStatusz[] = [
  'nem_ellenorzott', 'uj', 'elerve', 'kesobb_aktualis', 'szemle_egyeztetve', 'szemle_megtortent', 'megbizas', 'eladva', 'elveszett',
];

export const ELVESZETT_OK_CIMKE: Record<string, string> = {
  nem_elerheto: 'Nem elérhető',
  nem_akar_eladni: 'Mégsem akar eladni',
  csak_erdeklodott: 'Csak érdeklődött, nincs eladási szándék',
  masik_iroda: 'Másik irodát választott',
  arelvaras: 'Irreális árelvárás',
  kamu: 'Hamis adatok',
};

export const MEGBIZAS_TIPUS_CIMKE: Record<string, string> = {
  kizarolagos: 'Kizárólagos',
  nem_kizarolagos: 'Nem kizárólagos',
};

export const HIVAS_EREDMENY_CIMKE: Record<string, string> = {
  elerte: 'Elértem',
  nem_vette_fel: 'Nem vette fel',
  visszahivast_ker: 'Visszahívást kért',
};

export const SZEREP_CIMKE: Record<TagSzerep, string> = {
  vezeto: 'Irodavezető',
  ertekesito: 'Értékesítő',
};
